/**
 * package: com.inq.flash.client.data
 * class: ChatCommunicationSystemMessage
 * @extends com.inq.flash.client.data.ChatCommunicationMessage
 * @constructor
 */

com.inq.flash.client.data.ChatCommunicationSystemMessage = function(chat, text, position, context, cssClass) {
    com.inq.flash.client.data.ChatCommunicationMessage.call(this, chat, text);
    this.setMessageType(com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_SYSTEM);
    this.addPropertyIfNotNull(com.inq.flash.client.data.MessageFields.KEY_LINE_NR, position);
    this.addPropertyIfNotNull(com.inq.flash.client.data.MessageFields.KEY_CONTEXT, context);
    this.addPropertyIfNotNull(com.inq.flash.client.data.MessageFields.KEY_CSS_CLASS_NAME, cssClass);
};

$hxClasses.extend(com.inq.flash.client.data.ChatCommunicationMessage,
    com.inq.flash.client.data.ChatCommunicationSystemMessage,
    "com.inq.flash.client.data.ChatCommunicationSystemMessage"
);